import { useEffect } from "react";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { setTokenData } from "@redux/auth/tokenData";
import {
  getUserGroupData,
  verifyLoginToken,
  verifyLoginTokenCMS,
  verifyLoginTokenRGS,
} from "@services/userModule/UserService";
import { AppDispatch } from "@store/store";
import { setPermissions } from "@redux/auth/permission";
import { setUserData } from "@redux/auth/userSlice";
import { ROUTES } from "@routes/RouteConstant";
import useModal from "@hooks/useModal";
import Modal from "@components/modal/Modal";
import { setAuthenticated } from "@redux/auth/auth";

type EndpointPermission = {
  [endpointCode: string]: boolean;
};

export type ServicePermissions = {
  [serviceCode: string]: EndpointPermission;
};

const LoginVerification = () => {
  const history = useNavigate();
  const dispatch: AppDispatch = useDispatch();
  const { isOpen, modalInfo, openModal, closeModal } = useModal();

  function transformAccessDataToPermissions(data: any): ServicePermissions {
    const servicePermissions: ServicePermissions = {};

    data.access.forEach((service: any) => {
      const serviceCode = service.serviceCode;

      service.endpoints.forEach((endpoint: any) => {
        // if (endpoint.isActive) {
        if (!servicePermissions[serviceCode]) {
          servicePermissions[serviceCode] = {};
        }

        servicePermissions[serviceCode][endpoint.endpointCode] = true;
        // }
      });
    });

    return servicePermissions;
  }

  useEffect(() => {
    const queryString = window.location.hash;
    const urlParams = new URLSearchParams(queryString);
    const urltoken = urlParams.get("#id_token");

    const verifyLogin = async (_urltoken: string) => {
      try {
        const urlToken =
          import.meta.env.VITE_APP_MODE === "qa"
            ? import.meta.env.VITE_APP_TOKEN
            : _urltoken;
        const data = await verifyLoginToken(urlToken);

        await verifyLoginTokenRGS(urlToken);

        await verifyLoginTokenCMS(urlToken);

        const userData = await getUserGroupData(data?.userGroupId);
        console.log("User group  data fetched successfully:", userData);

        const permissonStucData = transformAccessDataToPermissions(userData);
        console.log("User permisson data", permissonStucData);

        dispatch(setAuthenticated(true));

        dispatch(
          setTokenData({
            // token: data?.token,
            // tokenexpires: data?.tokenexpires,
            portalProtected: false,
          }),
        );
        console.log("Token data set successfully:", data);

        dispatch(setPermissions({ permissions: permissonStucData }));

        dispatch(
          setUserData({
            ...userData,
            contactInfo: {
              name:
                data.contactInfo.firstName + " " + data.contactInfo.lastName,
              email: data.contactInfo?.emailAddress,
            },
            companyId: data.companyId,
          }),
        );

        history(ROUTES.PORTAL_REDIRECTION, { replace: true });
      } catch (error) {
        openModal({
          type: "error",
          title: "Email/User is not found or does not match within our system.",
          description:
            "Please make sure that the user is created within the User Management Portal.",
        });

        console.error("Login verification failed:", error);
        // Handle login verification failure
      }
    };
    if (urltoken === null) {
      //redirect them to home screen
      history("/", { replace: true });
    } else {
      verifyLogin(urltoken);
    }
  }, []); // initiate on the first load

  return (
    <Modal
      isOpen={isOpen}
      type={modalInfo?.type}
      title={modalInfo?.title}
      description={modalInfo?.description}
      onClose={() => {
        closeModal();
        history("/", { replace: true });
      }}
    />
  );
};

export default LoginVerification;
